<template>
  <div>
    <Header text="Winkelwagen" v-if="!hideHeader" />
    <div class="">
      <div class="row">
        <main class="col-sm-12">
          <div class="table-responsive">
            <table class="table table-hover shopping-cart-wrap">
              <tbody>
                <tr v-for="item in cartItems" :key="item.id">
                  <td>
                    <figure class="media" v-if="item.images">
                      <div class="img-wrap">
                        <img
                          :src="item.images[0].src"
                          class="img-thumbnail img-sm"
                        />
                      </div>
                      <figcaption class="media-body">
                        <h4 class="font-weight-bold text-truncate mb-0">
                          {{ item.name }}
                        </h4>
                      </figcaption>
                    </figure>
                  </td>
                  <td v-if="!isCheckout">
                    <div>
                      <QuantityInput
                        :value="item.quantity"
                        :disabled="item.stock_status !== 'outofstock'"
                        :canIncrement="item.stock_status !== 'outofstock'"
                        @increase="increaseQuantity(item)"
                        @decrease="decreaseQuantity(item)"
                        disableInput
                      />
                    </div>
                  </td>
                  <td>
                    <div class="price-wrap">
                      <span class="price">
                        {{ formatCurrency(item.price * item.quantity, true) }}
                      </span>
                      <small v-if="isCheckout" class="quantity-final">
                        Quantity: {{ item.quantity }}
                      </small>
                    </div>
                    <!-- price-wrap .// -->
                  </td>
                  <td v-if="!isCheckout" class="text-right">
                    <button class="btn-delete m-0" @click="showConfirm(item)">
                      <font-awesome-icon icon="fa-solid fa-trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="total-container">
              <h4><strong>Totaal</strong></h4>
              <h4>
                <strong> {{ formatCurrency(totalPrice, true) }} </strong>
              </h4>
            </div>
          </div>
          <div class="mt-4" v-if="!hideCart">
            <dl class="dlist-align h4">
              <button
                class="btn btn-primary"
                :disabled="!cartItems.length"
                @click="$router.push('/checkout')"
              >
                CHECK OUT
              </button>
            </dl>
          </div>

          <!-- card.// -->
        </main>
        <!-- col.// -->
      </div>
    </div>
    <transition name="fade">
      <ConfirmWindow
        v-if="confirmWindow"
        :item="clickedItem"
        @confirm="removeFromCart(clickedItem)"
        @cancel="hideConfirm"
        class="confirmWindow"
      />
    </transition>
  </div>
</template>

<script>
import "@/assets/fonts.scss";
import { formatCurrency } from "@/helpers/formatCurrency";
import QuantityInput from "@/components/QuantityInput";
import Header from "@/components/Header";
import ConfirmWindow from "@/components/ConfirmWindow";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("cart");

export default {
  props: {
    hideCart: Boolean,
    hideHeader: Boolean,
    isCheckout: Boolean,
  },
  components: {
    Header,
    ConfirmWindow,
    QuantityInput,
  },

  data() {
    return {
      clickedItem: null,
      confirmWindow: false,
    };
  },

  computed: {
    ...mapGetters(["totalPrice"]),
    ...mapState({
      cartItems: "items",
    }),
  },
  methods: {
    formatCurrency,
    handleBack() {
      this.$router.back();
    },
    removeFromCart(item) {
      this.$store.dispatch("cart/removeFromCart", item);
      this.hideConfirm();
    },
    showConfirm(item) {
      this.clickedItem = item;
      this.confirmWindow = true;
    },
    hideConfirm() {
      this.clickedItem = null;
      this.confirmWindow = false;
    },
    decreaseQuantity(item) {
      if (item.quantity == 1) {
        this.showConfirm(item);
      } else {
        this.$store.dispatch("cart/decreaseQuantity", item);
      }
    },
    ...mapActions(["increaseQuantity"]),
  },
};
</script>

<style lang="scss" scoped>
.header-wrap {
  display: flex;
  gap: 20px;
  align-items: center;
}

tr:hover {
  background-color: unset !important;
}

td {
  border-top: none;
  border-bottom: 1px solid #ddd;
  vertical-align: middle;
}

td > figure {
  margin-top: 8px;
}

td > * {
  align-items: center;
  display: flex;
}

.quantity-final {
  color: #999;
}

.btn-delete {
  border: none;
  border-radius: 999px;
  padding: 8px;
  background: #eee;
  color: #333;
}

.total-container {
  padding: 1.4rem;
  display: flex;
  justify-content: space-between;
  background: #eee;
  border-radius: 5px;
}

.total-container h4 {
  margin-bottom: 0;
}

.confirmWindow {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  // height: 200px;
  background: white;
  padding: 20px;
  border: 1px solid #ccc;
}

.shopping-cart-wrap img {
  max-width: 100px;
}

.media .img-wrap {
  margin-right: 1rem;
}

.shopping-cart-wrap h6 {
  font-size: 16px;
}

.price-wrap {
  flex-direction: column;
  font-weight: bold;
}

.price {
  color: var(--theme);
}
</style>
